import axios from '../config/axios';
import { Guia } from '../interfaces/guia';

const guiaService = {
  async list(params?: any): Promise<[Guia[], number]> {
    const { data } = await axios.get('/guias', { params });
    return data;
  },
  async get(id: number): Promise<Guia> {
    const { data } = await axios.get(`/guias/${id}`);
    return data;
  },
  async getSelf(id: number): Promise<Guia> {
    const { data } = await axios.get(`/guias/self/${id}`);
    return data;
  },
  async create(body: Guia): Promise<Partial<Guia>> {
    const { data } = await axios.post('/guias', body);
    return data;
  },
  async listSelf(params?: any): Promise<[Guia[], number]> {
    const { data } = await axios.get('/guias/self', { params });
    return data;
  },
  async export(ids?: number[], separator?: string): Promise<Blob> {
    const response = await axios.post(
      '/guias/export',
      { ids, separator },
      {
        responseType: 'blob',
        headers: {
          Accept: 'text/csv,application/csv'
        }
      }
    );
    return new Blob([response.data], {
      type: 'text/csv;charset=utf-8;'
    });
  }
};

export default guiaService;
